import { Directive, ElementRef, HostListener, Input, OnDestroy } from '@angular/core';

@Directive({
	selector: '[tooltip]',
})
export class UITooltipDirective implements OnDestroy {
	@Input('tooltip') tooltip = '';
	@Input() placement = 'top';
	@Input() delay = 300;

	tooltip_element: any = null;
	elem_position: any;
	tooltip_offset: number = 8;
	tooltip_timeout: any = null;
	tooltip_enabled: boolean = true;

	constructor(private element_ref: ElementRef) {}

	@HostListener('window:touchstart')
	onTouchStart(): void {
		this.tooltip_enabled = false;
	}

	@HostListener('mouseenter')
	onMouseEnter(): void {
		if (this.tooltip_enabled && this.tooltip !== null && this.tooltip !== '') {
			this.getElemPosition();
			document.body.appendChild(this.createElem());
			this.setPosition();
		}
	}

	@HostListener('mouseleave')
	@HostListener('click')
	onMouseLeave(): void {
		this.destroyElem();
	}

	getElemPosition(): void {
		this.elem_position = this.element_ref.nativeElement.getBoundingClientRect();
	}

	createElem(): HTMLElement {
		if (this.tooltip_element !== null) {
			this.tooltip_element.parentNode.removeChild(this.tooltip_element);
			this.tooltip_element = null;
		}

		this.tooltip_element = document.createElement('span');
		this.tooltip_element.className += 'tooltip position-' + this.placement;
		this.tooltip_element.textContent = this.tooltip;

		clearTimeout(this.tooltip_timeout);

		this.tooltip_timeout = setTimeout(() => {
			this.tooltip_element.className += ' show';
		}, this.delay);

		return this.tooltip_element;
	}

	setPosition(): void {
		const elem_height = this.element_ref.nativeElement.offsetHeight;
		const elem_width = this.element_ref.nativeElement.offsetWidth;
		const tooltip_height = this.tooltip_element.clientHeight;
		const tooltip_width = this.tooltip_element.offsetWidth;

		if (this.placement === 'top') {
			this.tooltip_element.style.top = this.elem_position.top - (tooltip_height + this.tooltip_offset) + 'px';
		}

		if (this.placement === 'bottom') {
			this.tooltip_element.style.top = this.elem_position.top + elem_height + this.tooltip_offset + 'px';
		}

		if (this.placement === 'top' || this.placement === 'bottom') {
			this.tooltip_element.style.left = this.elem_position.left + elem_width / 2 - tooltip_width / 2 + 'px';
		}

		if (this.placement === 'left') {
			this.tooltip_element.style.left = this.elem_position.left - tooltip_width - this.tooltip_offset + 'px';
		}

		if (this.placement === 'right') {
			this.tooltip_element.style.left = this.elem_position.left + elem_width + this.tooltip_offset + 'px';
		}

		if (this.placement === 'left' || this.placement === 'right') {
			this.tooltip_element.style.top =
				this.elem_position.top + elem_height / 2 - this.tooltip_element.clientHeight / 2 + 'px';
		}
	}

	destroyElem(): void {
		if (this.tooltip_enabled && this.tooltip !== null && this.tooltip !== '') {
			if (this.tooltip_element !== null) {
				clearTimeout(this.tooltip_timeout);
				this.tooltip_element.className = this.tooltip_element.className = this.tooltip_element.className.replace(
					'show',
					''
				);
				this.tooltip_timeout = setTimeout(() => {
					this.tooltip_element.parentNode.removeChild(this.tooltip_element);
					this.tooltip_element = null;
				}, 200);
			}
		}
	}

	ngOnDestroy(): void {
		this.destroyElem();
	}
}
